import React from 'react'
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getCountryCode } from '../UsefulComponent/CountryMapping';

import profile from "../../assets/svgs/profile.png";
const BigShowCompleteCard = ({ formData,isForCreate,showProfile,newVariation,previewImage,useMinHeight,showPrice,regularSize }) => {

 //onsole.log('BigShowCompleteCard',formData)
     const location = useLocation();

    
const navigate = useNavigate();
    const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
    const currentLang = i18n.language; // Access the current language
    const t = (key) => translations.CardGrid[key][currentLang]; // Adjust the path according to your JSON structure

    function triggerOnClickCard(formData) {
        // Create a sanitized card without Location if user IDs don’t match
      
        if(!isForCreate&&!previewImage&&showPrice)
        navigate(`/cards/${formData.usercardsId}`);
      }

    
      const cardStyle = {
        width: window.innerWidth < 768 ? '90vw' : 'clamp(180px, 12vw, 200px)',
        maxHeight: window.innerWidth < 768 ? 'none' : '44vh', // 🔼 Increase height on mobile
        // ...(useMinHeight && { minHeight: '45vh' }),
      };



   // console.log("formData 123", formData);
if(formData)
{
        return (
          
          <div
            className="cardcontentForm"
            onClick={() => triggerOnClickCard(formData)}
          >
               {showProfile===true &&<div
                                            className="user-profile"
                                            onClick={() =>
                                              navigate(`/ViewUserProfil/${formData.ShowName}`)
                                            }
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              //gap: "10px",
                                              justifySelf:'center',
                                              margin:'0px',
                                              cursor: "pointer",
                                            }}
                                          >
                    
                                            <img
                                              src={
                                                formData.ProfilPicture ? formData.ProfilPicture : profile
                                              }
                                              alt="User"
                                              className="profile-picture"
                                              style={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50%",
                                               marginRight:'0px'
                                              }}
                                             // Adjust size and shape as needed
                                            />
                                            <span
                                              className="ShowName"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                //gap: "5px",
                                              }}
                                            >
                                              <a
                                                style={{
                                                  textDecoration: "none",
                                                  color: "white",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {formData.ShowName} ({formData.NumberOfTransactions})
                                                {(formData.AverageRating * 20).toFixed(1)}%
                                                <img
                                                  src={`https://flagcdn.com/w40/${getCountryCode(
                                                    formData.Country || "ca"
                                                  ).toLowerCase()}.png`}
                                                  className="country-flag"
                                                  alt="flag"
                                                  style={{ marginLeft: "3px"}}
                                                 
                                                />
                                              </a>
                                              {/* <span className="rating" style={{ color: '#888', fontSize: '14px' }}>
                            
                          </span> */}
                                            </span>
                                          </div>
}
<div className={`card BigShowMobileStyle ${showPrice ? 'showPriceTrue' : 'showPriceFalse'} ${regularSize? 'regularSize' :''}`} >
              <div className="img">
                <img
                  style={{aspectRatio: "2.5 / 3.5"}}
                  className="card-image"
                  src={previewImage?previewImage:formData.ImageFront ? formData.ImageFront : formData.Image}
                  alt="Card Preview"
                />
                <div className="filter"></div>
                <div className="card-isWhat">
                  {/* Conditional Patches */}
                  {formData.IsRookie === "Rookie(RC)" && (
                    <div className="patch spe">
                      <p className="strong">RC</p>
                    </div>
                  )}
                  {formData.IsPatch === "Patch" && (
                    <div className="patch">
                      <p>Patch</p>
                    </div>
                  )}
                  {formData.IsJersey ==="Jersey" && (
                    <div className="patch">
                      <p>Jersey</p>
                    </div>
                  )}
                  {formData.IsAuto === "Auto" && (
                    <div className="patch">
                      <p>Auto</p>
                    </div>
                  )}
                  {formData.IsTribute === 1 && (
                    <div className="patch">
                      <p>Tribute</p>
                    </div>
                  )}

{formData.Graded === "Graded"||formData.Graded===true ? (
                                // <div className="patch cond">
                                <div className={`patch ${formData.GradeCompany.toLowerCase()} border absoRight`} >
                                  <p>
                                    {formData.GradeCompany} {formData.Grade}
                                  </p>
                                </div>
                              ) : (  <div className="patch cond">
                              <p>
                              {formData.ConditionCard}
                              </p>
                            </div>)}

                  {/* {formData.Numbered && formData.Numbered !== "0" && (
                    <div className="patch spe">
                      <p>/{formData.Numbered}</p>
                    </div>
                  )} */}
                </div>
              </div>
    
              <div
  className="txt"  style={{    gap: '1px',    minHeight: showPrice ? '12.5vh' : undefined}}>
                <div className="justify">
                  <h4 className="card-name">{formData.Name}</h4>
                  <p className="card-IDcard ">#{formData.NumberBehind}</p>
                </div>
                <p className="card-set">{formData.SetName}</p>
                <div className="flex-h">
                  <p className="card-variation">
                  
                    {isForCreate===true? (`${formData.cardName} - ${newVariation}`)
                    : (`${formData.cardName} - ${formData.variationName}`)}
                  </p>
                  {/* {formData.Numbered && formData.Numbered !== "0" ? (
                    <p className="card-numbered"> / {formData.Numbered} </p>
                  ) : null} */}
                </div>
    
                {/* {isForCreate===true?(<div className="ShowCompleteCard">
                 
                  {(formData.isForSale === "isForSale" || formData.isForSale === true)  && (
                    <div className="patch">
                      <p>{t("ForSale")}</p>
                    </div>
                  )}
                  {(formData.isPC === "isPC" || formData.isPC === true) && (
                    <div className="patch">
                      <p>PC</p>
                    </div>
                  )}
                  {(formData.isForTrade === "isForTrade" || formData.isForTrade === true) && (
                    <div className="patch">
                      <p>{t("ForTrade")}</p>
                    </div>
                  )}
                  {(formData.isOnEbay === "isOnEbay" || formData.isOnEbay === true) &&(
                    <div className="patch">
                      <p>{t("OnEbay")}</p>
                    </div>
                  )}
                </div>):(null)} */}
    
                {/* Display Price or TV if available */}
                {/* <div className="card-value" style={{marginBottom:'10px'}}>
                  {formData.EstimateValue&&isForCreate ? (
                    <h4>
                      ({t("Estimate/TV")}) {formData.EstimateValue}$
                    </h4>
                  ) : null}
    
                  {formData.Price >= 0 ? (
                    <h4>
                      ({t("Price")}) {formData.Price}$
                    </h4>
                  ) : null}
                     {formData.SalePrice >= 0 ? (
                    <h4>
                      ({t("Price")}) {formData.SalePrice}$
                    </h4>
                  ) : null}
                </div> */}


{showPrice && (() => {
  // normalize
  const isForSale =
    formData?.isForSale === 1 ||
    formData?.isForSale === true ||
    formData?.isForSale === "isForSale";

  const isForTrade =
    formData?.isForTrade === 1 ||
    formData?.isForTrade === true ||
    formData?.isForTrade === "isForTrade";

  const priceRaw = formData?.SalePrice ?? formData?.Price;
  const tvRaw    = formData?.EstimateValue;

  const priceNum = Number(priceRaw);
  const tvNum    = Number(tvRaw);

  const showPriceAmt = isForSale && Number.isFinite(priceNum) && priceNum >= 0;
  const showTVAmt    = isForTrade && Number.isFinite(tvNum) && tvNum >= 1;

  if (!showPriceAmt && !showTVAmt) return null;

  const fmt = (n) =>
    n.toLocaleString(undefined, {
      style: "currency",
      currency: "CAD",
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 0,
    });

  return (
    <div className="cta-row-grid">
      {showPriceAmt && (
        <div className="cta-leftStack">
          <span className="meta-label">{t("Price")}</span>
          <span className="meta-amount">{fmt(priceNum)}</span>
        </div>
      )}

      {showTVAmt && (
        <div className="cta-leftStack">
          <span className="meta-label">TV</span>
          <span className="meta-amount">{fmt(tvNum)}</span>
        </div>
      )}
    </div>
  );
})()}

                {/* {showPrice?(
(formData.Price >= 0 || formData.SalePrice >= 0 || formData.EstimateValue >= 0) && (
  <>
    {(formData.isForTrade === 1 || formData.isForTrade === true || formData.isForTrade === 'isForTrade')&& formData.EstimateValue  ? (
      <>
        <div className="price-line" style={{ margin:'auto auto 0.75vh auto' }}>
          <span className="label-card-grid" style={{ marginLeft: '0px', marginRight: '0px' }}>
            {t("Price")}
          </span>

          <span className="price-value-box">
            {(formData.SalePrice ?? formData.Price) !== null && (formData.SalePrice ?? formData.Price) >= 0
              ? `${formData.SalePrice ?? formData.Price}$`
              : "-"}
          </span>

          <span className="label-card-grid" style={{ marginRight: '0px' }}>TV</span>
          <span className="price-value-box">{formData.EstimateValue}$</span>
        </div>
      </>
    ) : (
      <div className="price-value-box">
        <div className="price-value-row" style={{ fontSize: '1.1rem', fontWeight: '700' }}>
          {(formData.SalePrice ?? formData.Price) !== null && (formData.SalePrice ?? formData.Price) >= 0
            ? `${formData.SalePrice ?? formData.Price}$`
            : "-"}
        </div>
      </div>
    )}
  </>
)  ):null} */}



{/* 
{card.isForSale ==='isForSale' && (
  <div className="price-line">
    {/* <span className="label-card-grid">{t("Price")}</span> */}
    {/* <span className="value-card-grid">
      {card.Price === -1 || card.Price === null ? "0$" : `${card.Price}$`}
    </span> *
        <span className="price-value-box">
      {card.Price === -1 || card.Price === null ? "0$" : `${card.Price}$`}
    </span>
    
  </div>
)}

{card.EstimateValue>=1 && card.isForTrade === 'isForTrade' && (
  <div className="price-line" style={{marginLeft:'25%'}}>
    <span className="label-card-grid">TV</span>
    {/* <span className="value-card-grid">{card.EstimateValue}$</span> 
    <span className="price-value-box">{card.EstimateValue}$</span>
    
  </div>
)} */}


              </div>
            </div>
          </div>
        );
      }
      };

      function areEqual(prevProps, nextProps) {
        const a = prevProps.formData;
        const b = nextProps.formData;
      
        const sameFormData =
          a.ID === b.ID &&
          a.userCardId === b.userCardId &&
          a.ImageFront === b.ImageFront &&
          a.Image === b.Image &&
          a.Price === b.Price &&
          a.SalePrice === b.SalePrice &&
          a.EstimateValue === b.EstimateValue &&
          a.Name === b.Name &&
          a.NumberBehind === b.NumberBehind &&
          a.cardName === b.cardName &&
          a.variationName === b.variationName;
      
        const sameProps =
          prevProps.isForCreate === nextProps.isForCreate &&
          prevProps.showProfile === nextProps.showProfile &&
          prevProps.newVariation === nextProps.newVariation &&
          prevProps.previewImage === nextProps.previewImage &&
          prevProps.useMinHeight === nextProps.useMinHeight;
      
        return sameFormData && sameProps;
      }

      export default React.memo(BigShowCompleteCard, areEqual);